function gastonSetExternalLinkTargets(root = document) {
  const currentOrigin = window.location.origin;

  root.querySelectorAll('a[href]').forEach((link) => {
    if (link.getAttribute('target') === '_blank') return;

    const href = link.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;

    try {
      const url = new URL(href, window.location.href);
      if (url.origin !== currentOrigin) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    } catch {
      /* ignore invalid URLs */
    }
  });
}

document.addEventListener('DOMContentLoaded', () => gastonSetExternalLinkTargets());
document.addEventListener('shopify:section:load', (event) => gastonSetExternalLinkTargets(event.target));
